import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "element-loading-background": "rgba(0, 0, 0, 0.5)" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 选择产品信息 ", -1)
const _hoisted_3 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-6px","margin-right":"-10px"} }
const _hoisted_4 = { style: {"float":"right","margin-right":"10px"} }
const _hoisted_5 = { style: {"height":"600px"} }
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["title"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = ["title"]
const _hoisted_15 = ["title"]
const _hoisted_16 = ["title"]
const _hoisted_17 = ["title"]
const _hoisted_18 = { style: {"clear":"both","float":"right","margin-top":"15px","height":"25px"} }
const _hoisted_19 = { style: {"clear":"both","height":"25px","padding-top":"3px"} }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 搜索 ", -1)
const _hoisted_21 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_22 = { class: "link" }
const _hoisted_23 = { class: "link" }
const _hoisted_24 = { class: "link" }
const _hoisted_25 = { class: "link" }
const _hoisted_26 = { style: {"clear":"both","height":"25px"} }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 规格图片 ", -1)
const _hoisted_28 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_29 = { style: {"width":"100% !important"} }
const _hoisted_30 = { style: {"width":"100%","height":"100%","text-align":"center","background-color":"#fff"} }
const _hoisted_31 = ["href"]
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"90px"} }, null, -1)
const _hoisted_34 = { style: {"clear":"both"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Search = _resolveComponent("Search")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.ruleForm.Visible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.Visible) = $event)),
      top: "0px",
      "show-close": false,
      style: {"width":"96%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isSelectCompany == true)
            ? (_openBlock(), _createBlock(_component_el_select, {
                key: 0,
                size: "small",
                modelValue: _ctx.selectCompanyId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectCompanyId) = $event)),
                style: {"margin-right":"10px"},
                placeholder: "请选择",
                onChange: _ctx.onChangeCompany
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companys, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.Id,
                      label: item.Name,
                      value: item.Id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            onClick: _ctx.handleSearch
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Search)
                ]),
                _: 1
              }),
              _createTextVNode(" 搜索")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "customsPackageRuleForm",
          model: _ctx.list.Data
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_table, {
                ref: "customsPackageTable",
                data: _ctx.list.Data.Items,
                onSelectionChange: _ctx.handleSelectionChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    type: "selection",
                    width: "55"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "Code",
                    label: "包装编号",
                    width: "120px"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        style: {"width":"100% !important","word-break":"break-all","overflow":"hidden","height":"26px","line-height":"26px"},
                        title: scope.row.Code
                      }, _toDisplayString(_ctx.isString(scope.row.Code)), 9, _hoisted_6)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "NameZh",
                    label: "包装种类（中）",
                    width: "240px"
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.PackageZh)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"width":"100% !important","word-break":"break-all","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.PackageZh.Name
                          }, _toDisplayString(_ctx.isString(scope.row.PackageZh.Name)), 9, _hoisted_7))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, "暂无数据"))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "PackageEn",
                    label: "包装种类（英）",
                    width: "150px"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","height":"26px","line-height":"26px"},
                        title: scope.row.PackageEn
                      }, _toDisplayString(_ctx.isString(scope.row.PackageEn)), 9, _hoisted_9)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "PackageImages",
                    label: "包装的图片",
                    width: "150px"
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.PackageImages!=null && scope.row.PackageImages!=undefined && scope.row.PackageImages.length>0)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            style: {"cursor":"pointer","color":"#fe995b","font-weight":"900"},
                            onClick: ($event: any) => (_ctx.onImage(scope.row))
                          }, " 查看 ", 8, _hoisted_10))
                        : (_openBlock(), _createElementBlock("span", _hoisted_11, "暂无数据"))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "SizeQuantity",
                    label: "尺寸与数量"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","height":"26px","line-height":"26px"},
                        title: scope.row.SizeQuantity
                      }, _toDisplayString(_ctx.isString(scope.row.SizeQuantity)), 9, _hoisted_12)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "NetWeight",
                    label: "净重（KGS）",
                    width: "120px"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","height":"26px","line-height":"26px"},
                        title: scope.row.NetWeight
                      }, _toDisplayString(_ctx.isString(scope.row.NetWeight)), 9, _hoisted_13)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "GrossWeight",
                    label: "毛重（KGS）",
                    width: "120px"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","height":"26px","line-height":"26px"},
                        title: scope.row.GrossWeight
                      }, _toDisplayString(_ctx.isString(scope.row.GrossWeight)), 9, _hoisted_14)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "Volume",
                    label: "体积（CBM）",
                    width: "120px"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                        title: scope.row.Volume
                      }, _toDisplayString(_ctx.isString(scope.row.Volume)), 9, _hoisted_15)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "ProductName",
                    label: "产品名称"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                        title: scope.row.ProductName
                      }, _toDisplayString(_ctx.isString(scope.row.ProductName)), 9, _hoisted_16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "Quantity",
                    label: "数量",
                    width: "180px"
                  }, {
                    header: _withCtx(() => [
                      _createTextVNode(" 数量 ")
                    ]),
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                        title: scope.row.Quantity
                      }, [
                        (scope.row.IsSelected == true)
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 0,
                              "label-width": "0px",
                              label: "",
                              prop: 'Items.' + scope.$index + '.Quantity',
                              rules: [
                      {
                        required: true,
                        message: '信息不能为空',
                        trigger: 'blur',
                      },
                    ]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  placeholder: "请填写",
                                  disabled: false,
                                  modelValue: scope.row.Quantity,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.Quantity) = $event),
                                  onBlur: ($event: any) => (_ctx.onChangeQuantity(scope.$index))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
                              ]),
                              _: 2
                            }, 1032, ["prop"]))
                          : (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 1,
                              "label-width": "0px",
                              label: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  placeholder: "请填写",
                                  disabled: true,
                                  modelValue: scope.row.Quantity,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.Quantity) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1024))
                      ], 8, _hoisted_17)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "onSelectionChange"]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.ruleForm.CurrentPage,
                  onCurrentChange: _ctx.handleCurrentChange,
                  small: true,
                  background: "",
                  layout: "total, prev, pager, next, jumper",
                  total: _ctx.ruleForm.Total
                }, null, 8, ["current-page", "onCurrentChange", "total"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.bottomButtons,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClick
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.searchForm!= undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.searchForm.Visiable,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.searchForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"50%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref: "refSearchForm",
              modelValue: _ctx.list.Dto,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.list.Dto) = $event)),
              fix: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          "label-width": "120px",
                          label: "包装编号"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_autocomplete, {
                              modelValue: _ctx.list.Dto.SearchCode,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.list.Dto.SearchCode) = $event)),
                              clearable: true,
                              style: {"width":"100% !important"},
                              "fetch-suggestions": _ctx.querySearchCodeAsync,
                              "popper-class": "my-autocomplete",
                              placeholder: "请填写关键词",
                              onSelect: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSelectCode($event,_ctx.model)))
                            }, {
                              default: _withCtx(({ item }) => [
                                _createElementVNode("span", _hoisted_22, _toDisplayString(item.Label), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "fetch-suggestions"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          "label-width": "120px",
                          label: "产品名称"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_autocomplete, {
                              modelValue: _ctx.list.Dto.SearchProductName,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.list.Dto.SearchProductName) = $event)),
                              clearable: true,
                              style: {"width":"100% !important"},
                              "fetch-suggestions": _ctx.querySearchProductNameAsync,
                              "popper-class": "my-autocomplete",
                              placeholder: "请填写关键词",
                              onSelect: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleSelectProductName($event,_ctx.model)))
                            }, {
                              default: _withCtx(({ item }) => [
                                _createElementVNode("span", _hoisted_23, _toDisplayString(item.Label), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "fetch-suggestions"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          "label-width": "120px",
                          label: "包装种类（中）"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.list.Dto.SearchTypeZh,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.list.Dto.SearchTypeZh) = $event)),
                              filterable: "",
                              clearable: "",
                              placeholder: "请选择"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packages, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.Label,
                                    label: item.Label,
                                    value: item.Label
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          "label-width": "120px",
                          label: "包装种类（英）"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.list.Dto.SearchTypeEn,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.list.Dto.SearchTypeEn) = $event)),
                              filterable: "",
                              clearable: "",
                              placeholder: "请选择"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packageEnHistorys, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.Label,
                                    label: item.Label,
                                    value: item.Label
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          "label-width": "120px",
                          label: "型号/规格"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_autocomplete, {
                              modelValue: _ctx.list.Dto.SearchSpec,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.list.Dto.SearchSpec) = $event)),
                              clearable: true,
                              style: {"width":"100% !important"},
                              "fetch-suggestions": _ctx.querySearchSpecAsync,
                              "popper-class": "my-autocomplete",
                              placeholder: "请填写关键词",
                              onSelect: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleSelectSpec($event,_ctx.model)))
                            }, {
                              default: _withCtx(({ item }) => [
                                _createElementVNode("span", _hoisted_24, _toDisplayString(item.Label), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "fetch-suggestions"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          "label-width": "120px",
                          label: "货号"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_autocomplete, {
                              modelValue: _ctx.list.Dto.SearchNumber,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.list.Dto.SearchNumber) = $event)),
                              clearable: true,
                              style: {"width":"100% !important"},
                              "fetch-suggestions": _ctx.querySearchSpecNumberAsync,
                              "popper-class": "my-autocomplete",
                              placeholder: "请填写关键词",
                              onSelect: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleSelectSpecNumber($event,_ctx.model)))
                            }, {
                              default: _withCtx(({ item }) => [
                                _createElementVNode("span", _hoisted_25, _toDisplayString(item.Label), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "fetch-suggestions"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.searchButtons,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.searchButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickSearch
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.imageForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.imageForm.Visiable,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.imageForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"50%"},
          top: "30px",
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_el_carousel, {
                interval: 5000,
                arrow: "always"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageForm.Rows, (p, index) => {
                    return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("a", {
                            href: p.Url,
                            target: "_blank"
                          }, [
                            _createElementVNode("img", {
                              style: {"height":"100%"},
                              src: p.Url
                            }, null, 8, _hoisted_32)
                          ], 8, _hoisted_31)
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.bottomButtonsImage,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.bottomButtonsImage) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickImage
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}